import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/icon/youtube_icon.svg")